import { render, staticRenderFns } from "./BottomNavBlock.vue?vue&type=template&id=cc3c8ac2&scoped=true&"
import script from "./BottomNavBlock.vue?vue&type=script&lang=js&"
export * from "./BottomNavBlock.vue?vue&type=script&lang=js&"
import style0 from "./BottomNavBlock.vue?vue&type=style&index=0&id=cc3c8ac2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc3c8ac2",
  null
  
)

export default component.exports